import clsx from 'clsx';

interface UsageBarProps {
  used: number;
  total: number;
  label?: string;
  showDetails?: boolean;
  className?: string;
}

export function UsageBar({
  used,
  total,
  label,
  showDetails = true,
  className,
}: UsageBarProps) {
  const percentage = total > 0 ? Math.min(100, Math.max(0, (used / total) * 100)) : 0;
  const remaining = Math.max(0, total - used);

  let gradientClass = 'from-cyan-500 to-blue-600';
  if (percentage >= 90) {
    gradientClass = 'from-amber-500 to-red-500';
  } else if (percentage >= 75) {
    gradientClass = 'from-amber-400 to-amber-600';
  }

  return (
    <div className={clsx('w-full', className)}>
      {label && (
        <div className="flex justify-between items-end mb-2">
          <span className="text-sm font-medium text-slate-300">{label}</span>
          <span className="text-sm text-slate-400">
            {used.toLocaleString()} / {total.toLocaleString()}
          </span>
        </div>
      )}

      <div className="h-4 w-full bg-slate-700 rounded-full overflow-hidden relative">
        <div
          className={clsx(
            'h-full bg-gradient-to-r transition-all duration-500 ease-out rounded-full',
            gradientClass,
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>

      {showDetails && (
        <div className="flex justify-between items-center mt-3 text-sm">
          <div className="text-slate-400">
            <span className="text-white font-medium">
              {remaining.toLocaleString()}
            </span>{' '}
            remaining
          </div>
          <div className="text-slate-400">{percentage.toFixed(0)}% used</div>
        </div>
      )}
    </div>
  );
}
